import React from "react";
import "./ui/retractable-floating-launcher.css";

type Props = {
  children: React.ReactNode;
};

const FloatingActions: React.FC<Props> = ({ children }) => (
  <div className="floating-actions">{children}</div>
);

export default FloatingActions;
